import React from 'react';
import {GridColDef} from '@mui/x-data-grid-pro';
import {Box, Stack} from '@mui/material';

import {ColumnProps} from '@utils/table/columnTypes.table';
import {Array} from '@utils/extensions/array.extension';

interface IconsColumnProps extends ColumnProps {
  icons?: {
    hidden?: (row: any) => boolean;
    icon: JSX.Element;
  }[];
}

export const COLUMN_TYPE_ICONS = (props: IconsColumnProps): GridColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label,
  minWidth: props.minWidth ?? 50,
  sortable: props.sortable ?? false,
  editable: false,
  renderCell: (params) => {
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        {(props.icons ?? []).map((icon, index) => icon.hidden?.(params.row)
          ? <div key={`${params.row.id} icon ${index}`} style={{width: 18, height: 21}}/>
          : <Box key={`${params.row.id} icon ${index}`}>{icon.icon}</Box>
        )}
      </Stack>
    );
  },
  renderEditCell: (params) => {
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        {(props.icons ?? []).map((icon, index) => icon.hidden?.(params.row)
          ? <div key={`${params.row.id} icon ${index}`} style={{width: 18, height: 21}}/>
          : <Box key={`${params.row.id} icon ${index}`}>{icon.icon}</Box>
        )}
      </Stack>
    );
  },
  valueGetter: props.valueGetter,
  valueFormatter: props.valueFormatter,
  width: props.width ?? 150,
});